import { View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { tableStyles } from './tableStyles.ts';

export const Table = ({ children }: PropsWithChildren) => (
  <View style={tableStyles.table}>{children}</View>
);
